import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import * as g from 'src/global-variables';

@Component({
  selector: 'app-attribute-group',
  templateUrl: './attribute-group.component.html',
  styleUrls: ['./attribute-group.component.less']
})
export class AttributeGroupComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() mode: string;
  @Output() submitChanges: EventEmitter<any> = new EventEmitter();

  entitiesValues = g.Entities;

  constructor() {}

  ngOnInit(): void {}

  submit() {
    this.submitChanges.emit();
  }

  recordLoaded(record: any) {}

  beforeSubmit() {}

  cleanRecord(record: any) : any{
    return record;
  }

  static controls(mode: string) {
    const controlsToReturn: any = {};
    if(mode === 'edit') {
      controlsToReturn['Id'] = [null, []];
    }

    controlsToReturn['Name'] = [null, [Validators.required]];
    controlsToReturn['RelatedObjectType'] = [null, [Validators.required]];
    controlsToReturn['Description'] = [null, []];

    return controlsToReturn;
  }
}
